var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1439_328",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.06189C12.6724 4.02104 12.3387 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.6613 19.979 11.3276 19.9381 11L13 11L13 4.06189Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.06189L15 4.06189L15 2.2958L13.2475 2.07726L13 4.06189ZM19.9381 11L21.9227 10.7525L21.7042 9L19.9381 9L19.9381 11ZM13 11L11 11L11 13L13 13L13 11ZM12 6C12.2557 6 12.5068 6.01588 12.7525 6.04652L13.2475 2.07726C12.838 2.0262 12.4216 2 12 2L12 6ZM6 12C6 8.68629 8.68629 6 12 6L12 2C6.47715 2 2 6.47715 2 12L6 12ZM12 18C8.68629 18 6 15.3137 6 12L2 12C2 17.5228 6.47715 22 12 22L12 18ZM18 12C18 15.3137 15.3137 18 12 18L12 22C17.5228 22 22 17.5228 22 12L18 12ZM17.9535 11.2475C17.9841 11.4932 18 11.7443 18 12L22 12C22 11.5784 21.9738 11.162 21.9227 10.7525L17.9535 11.2475ZM19.9381 9L13 9L13 13L19.9381 13L19.9381 9ZM15 11L15 4.06189L11 4.06189L11 11L15 11Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_1439_328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.08296C17.5125 4.50448 19.4955 6.48749 19.917 9L15 9L15 4.08296Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie_chart.c96453cffba1011867dd5fe425062bcc.svg";
export { ForwardRef as ReactComponent };